import HouseSearchApi from '../store/HouseSearchApi';

export default class RetrySearchButton extends HTMLButtonElement {
    readonly #api = HouseSearchApi.getInstance();

    #clickHandler(): void {
        this.#api.update();
    }

    connectedCallback(): void {
        this.addEventListener('click', this.#clickHandler);
    }

    disconnectedCallback(): void {
        this.removeEventListener('click', this.#clickHandler);
    }
}

if (!customElements.get('retry-search-button')) {
    customElements.define('retry-search-button', RetrySearchButton, { extends: 'button' });
}
